import { render, staticRenderFns } from "./curUserDetail.vue?vue&type=template&id=5bbb8f0a&"
import script from "./curUserDetail.vue?vue&type=script&lang=js&"
export * from "./curUserDetail.vue?vue&type=script&lang=js&"
import style0 from "./curUserDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports